import EbLoading from './loading'
let instance = null
/**
 * 怪兽logo 加载动画
 * @method : 调用弹层  this.$ebLoading.show()
 * @method : 关闭弹层  this.$ebLoading.hide()
 * show()支持自定义文案
 * @method show(options) : { text : '加载中....'} 默认 : loading...
 */
export default {
  install (Vue) {
    if (!instance) {
      const EbLoadingCompontent = Vue.extend(EbLoading)
      /**
       * 1. appendChild到页面某个元素
       */
      instance = new EbLoadingCompontent({
        el: document.createElement('div')
      })
      document.body.appendChild(instance.$el)
      /**
       * 2. new实例后使用 $mount() 方法挂载
       */
      // new EbLoadingCompontent().$mount('#iui')
    }
    console.log('instance------', instance)
    instance.isShow = false // 默认false 关闭loading弹窗
    /**
     * instance 为Vue基础构造器（Vue.extend()）创建出来的子类，里面有组件的所有参数(data, methods)等
     * instance 实例后就直接能够修改组件内的参数或者执行发发
     */

    // 自动移方法操作组件内部参数或者方法
    const customMethods = {
      show (options) {
        instance.isShow = true
        if (options && 'text' in options) {
          instance.loadingText = options.text
        }
      },
      hide () {
        instance.isShow = false
      }
    }

    // 挂载自定义方法到Vue实例上
    if (!Vue.$ebLoading) {
      Vue.$ebLoading = customMethods
      Vue.prototype.$ebLoading = Vue.$ebLoading
      console.log('Vue.$ebLoading------', Vue.$ebLoading)
    } else {
      console.log('$ebLoading 方法已被占用')
    }
  }
}
